export default {
  contact_hero_title: 'CONT\u00C1CTANOS',

  quick_call: 'Ll\u00E1manos',
  quick_email: 'Env\u00EDanos un Correo',
  quick_follow: 'S\u00EDguenos',
  quick_area: '\u00C1rea de Servicio',

  panel_company: 'FMO LLC Servicios de Aislamiento',
  panel_desc: 'Soluciones profesionales de aislamiento para propiedades residenciales y comerciales en Lafayette, Indiana. Espuma spray, paneles, celulosa, soplado, \u00E1tico, paredes y s\u00F3tanos con m\u00E1s de 15 a\u00F1os de experiencia.',
  panel_area_title: '\u00C1rea de Servicio',
  panel_area_main: 'Lafayette, Indiana',
  panel_area_sub: 'y Comunidades Cercanas',
  panel_hours_title: 'Horario de Atenci\u00F3n',
  panel_hours_weekdays: 'Lun - S\u00E1b: 8:00 AM - 5:00 PM',
  panel_hours_weekends: 'Dom: Cerrado',
  panel_why_title: '\u00BFPor Qu\u00E9 Elegir FMO LLC?',
  panel_why_1: 'Presupuestos gratis sin compromiso',
  panel_why_2: 'Respuesta en menos de 24 horas',
  panel_why_3: 'Servicio profesional garantizado',
  panel_why_4: 'Sirviendo a Lafayette y \u00E1reas cercanas',
  panel_cta: 'Completa el formulario a la derecha y recibe tu presupuesto personalizado hoy.',

  form_badge: 'SOLICITA UN PRESUPUESTO GRATIS',
  form_title: 'Completa el formulario y te responderemos r\u00E1pido',
  form_placeholder_name: 'Ingresa tu nombre',
  form_placeholder_last: 'Ingresa tu apellido',
  form_placeholder_email: 'Ingresa tu correo electr\u00F3nico',
  form_placeholder_phone: 'Ingresa tu n\u00FAmero de tel\u00E9fono',
  form_placeholder_address: 'Ingresa la direcci\u00F3n de tu propiedad',
  form_placeholder_message: 'Cu\u00E9ntanos sobre tu propiedad y lo que necesitas...',
  form_char_count: '{{count}}/500',
  form_submit: '\u00A1Solicita tu Presupuesto Gratis! \uD83D\uDC49',
};